export const REQUEST_MASTER_CASESTUDY = "REQUEST_MASTER_CASESTUDY";
export const SET_MASTER_CASESTUDY = "SET_MASTER_CASESTUDY";
export const ERROR_GET_MASTER_CASESTUDY = "ERROR_GET_MASTER_CASESTUDY";

export const REQUEST_CREATE_MASTER_CASESTUDY =
  "REQUEST_CREATE_MASTER_CASESTUDY";
export const SUCCESS_CREATE_MASTER_CASESTUDY =
  "SUCCESS_CREATE_MASTER_CASESTUDY";
export const ERROR_CREATE_MASTER_CASESTUDY = "ERROR_CREATE_MASTER_CASESTUDY";

export const REQUEST_UPDATE_MASTER_CASESTUDY =
  "REQUEST_UPDATE_MASTER_CASESTUDY";
export const SUCCESS_UPDATE_MASTER_CASESTUDY =
  "SUCCESS_UPDATE_MASTER_CASESTUDY";
export const ERROR_UPDATE_MASTER_CASESTUDY = "ERROR_UPDATE_MASTER_CASESTUDY";

export const REQUEST_DELETE_MASTER_CASESTUDY =
  "REQUEST_DELETE_MASTER_CASESTUDY";
export const SUCCESS_DELETE_MASTER_CASESTUDY =
  "SUCCESS_DELETE_MASTER_CASESTUDY";
export const ERROR_DELETE_MASTER_CASESTUDY = "ERROR_DELETE_MASTER_CASESTUDY";

export const SET_MESSAGE_MASTER_CASESTUDY = "SET_MESSAGE_MASTER_CASESTUDY";

export const SET_META_DATA_FOR_PAGINATION = "SET_META_DATA_FOR_PAGINATION";

export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";